import { render, staticRenderFns } from "./Rentals.vue?vue&type=template&id=3a6fe4b6"
import script from "./Rentals.vue?vue&type=script&lang=ts"
export * from "./Rentals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports